define(
    'BTM.BRPersonalization.BRSuppressPersonalizationOption'
    , [
        'BTM.BRPersonalization.BRSuppressPersonalizationOption.View',
        'BTM.BRPersonalization.BRSuppressPersonalizationOption.QuickView'
        , 'Item.Model'
        , 'Item.Option.Collection'
        , 'Cart.Confirmation.Helpers'
        , 'SC.Configuration'
        , 'Utils'
        , 'underscore'
        , 'ProductViews.Option.View'
        , 'require'
    ]
    , function (
        BRSuppressPersonalizationOptionView,
        BRSuppressPersonalizationOptionQuickView,
        ItemModel,
        ItemOptionCollection,
        CartConfirmationHelpers,
        Configuration,
        Utils,
        _,
        ProductViewsOptionView,
        require
    ) {
        'use strict';

        return {
            mountToApp: function mountToApp(container) {

                // Suppress options and set maxlength
                ProductViewsOptionView.prototype.getContext = _.wrap(ProductViewsOptionView.prototype.getContext, function (fn) {
                    var context = fn.apply(this, _.toArray(arguments).slice(1));
                    var option = this.model;
                    var id = option.get('cartOptionId');
                    if (id && id.indexOf("_") > 0) {
                        if (id.indexOf("custcol_br_po") === -1) {
                            context.isHidden = true;
                        } else {
                            try {
                                var ids = id.split("_");
                                var maxlen = parseInt(ids[ids.length - 1], 10);
                                if (maxlen > 0) {
                                    context.maxlength = maxlen;
                                    context.placeholder = "Maximum " + maxlen + " characters";
                                }
                            } catch (error) {
                            }
                        }
                    }
                    return context;
                });

                var pdp = container.getComponent('PDP');
                try {
                    var ErrorManagementResponseErrorParser = require('ErrorManagement.ResponseErrorParser');
                    CartConfirmationHelpers.showCartConfirmation = function showCartConfirmation(cart_promise, line, application) {
                        // Available values are: goToCart, showMiniCart and showCartConfirmationModal
                        this['_' + Configuration.get('addToCartBehavior', 'showCartConfirmationModal')](cart_promise, line, application);

                        var layout = application.getLayout();

                        cart_promise.fail(function (error) {
                            var output_message = ''
                                , error_object = (error && error.responseJSON) || {}
                                , error_message = ErrorManagementResponseErrorParser(error, layout.errorMessageKeys);

                            //if the error was caused by an extension canceling the operation, then show the error message from the back-end
                            if (error_object.errorCode === 'ERR_EXT_CANCELED_OPERATION' && error_message) {
                                output_message = error_message;
                            } else {
                                output_message = _('Sorry, there is a problem with this Item and can not be purchased at this time. Please check back later.').translate();
                                if (error_message.indexOf('custcol') != -1) {
                                    var arrErrorStr = error_message.split(" ");
                                    var colIds = arrErrorStr.filter(function (value) {
                                        return value.indexOf('custcol') == 0;
                                    });
                                    var replaceName = [];
                                    // looking field name array
                                    var optionview = $('div[data-view="Options.Collection"]');
                                    for (var i = 0; i < colIds.length; i++) {
                                        var custCols = optionview.find('label[for="' + colIds[i] + '"]');
                                        if (custCols) {
                                            replaceName[i] = custCols.get(0).innerText;
                                        } else {
                                            replaceName[i] = colIds[i];
                                        }
                                    }
                                    var detail = error_message;
                                    for (var i = 0; i < colIds.length; i++) {
                                        detail = detail.replace(colIds[i], replaceName[i]);
                                    }
                                    output_message += ("<br/>Detail: " + detail);
                                } else {
                                    output_message += ("<br/>Detail: " + error_message);
                                }
                            }

                            layout.showErrorInModal(output_message);
                        });
                    };
                } catch (err) {
                }

                if (pdp) {
                    pdp.addChildView('Options.Collection', function () {
                        return new BRSuppressPersonalizationOptionView({container: container});
                    });
                    pdp.addChildViews(
                        pdp.PDP_QUICK_VIEW, {
                            'Options.Collection': {
                                'BRPersonalization': {
                                    childViewIndex: 11,
                                    childViewConstructor: function () {
                                        return new BRSuppressPersonalizationOptionQuickView({container: container});
                                    }
                                }
                            }
                        }
                    );
                }

            }
        };
    });
